import { SessionsState } from "./types";

export function getDefaultState(): SessionsState {
    return {
        sessions: { 2: "", 3: "" },
        requestStatus: 0
    }
}
